import { forwardRef, useState } from "react";
import { Eye, EyeOff } from "lucide-react";

/**
 * PasswordInput — password field with an independent show/hide toggle.
 *
 * Wraps the existing `.input` styling (adds right padding to make room for the
 * icon button). Never `type="submit"` on the toggle — regression: partial
 * password + click on eye must NOT submit the surrounding form.
 *
 * Visibility state is component-local and does NOT persist across mounts.
 */
const PasswordInput = forwardRef(function PasswordInput(
    { className = "", "data-testid": dataTestId, toggleTestId, ...inputProps },
    ref
) {
    const [visible, setVisible] = useState(false);
    const toggle = () => setVisible((v) => !v);
    const Icon = visible ? EyeOff : Eye;
    const label = visible ? "Hide password" : "Show password";
    return (
        <div className="relative">
            <input
                {...inputProps}
                ref={ref}
                type={visible ? "text" : "password"}
                className={`input pr-12 ${className}`.trim()}
                data-testid={dataTestId}
            />
            <button
                type="button"
                onClick={toggle}
                aria-label={label}
                aria-pressed={visible}
                title={label}
                className="pw-toggle"
                data-testid={toggleTestId || (dataTestId ? `${dataTestId}-toggle` : undefined)}
                tabIndex={0}
            >
                <Icon size={20} strokeWidth={2} aria-hidden />
            </button>
        </div>
    );
});

export default PasswordInput;
